/**
 * These are locales supported by the 20|20 platform, and hence
 * by Stitch and related services.
 */
export const supportedLocales = [
  'af-ZA',
  'bg-BG',
  'de-DE',
  'en-US',
  'es-AR',
  'es-MX',
  'fr-CA',
  'fr-FR',
  'hu-HU',
  'it-IT',
  'pl-PL',
  'pt-BR',
  'ro-RO',
  'ru-RU',
  'uk-UA',
  'zh-CN'
] as const

export type SupportedLocale = (typeof supportedLocales)[number]

/**
 * ISO-639-1 language codes underlying `supportedLocales`, with regional
 * variants (e.g. `es-AR` / `es-MX`) collapsed to one entry. A `Record`
 * keyed by this type — rather than by `string` — fails to compile when a
 * newly added locale's language isn't accounted for.
 */
export type SupportedLanguage = SupportedLocale extends `${infer Language}-${string}`
  ? Language
  : never

const supportedLanguages = new Set(supportedLocales.map((locale) => locale.split('-')[0]))

export function isSupportedLocale(locale: string): locale is SupportedLocale {
  return supportedLocales.some((supported) => supported === locale)
}

export function isSupportedLanguage(language: string): language is SupportedLanguage {
  return supportedLanguages.has(language)
}
